import React from "react";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  return (
    <div className="md:px-10 px-4">
      <button
        onClick={() => {
          navigate(-1);
        }}
        className="my-5 bg-green-500 rounded-xl shadow-xl p-2"
      >
        <IoArrowBack className="text-white text-2xl"></IoArrowBack>
      </button>
      <p>
        <strong>Novelio Technologies Private Limited - Northstarz.Ai</strong>
      </p>
      <p>General Terms &amp; Conditions</p>
      <ol>
        <li>Acceptance of Terms</li>
      </ol>
      <p>
        By accessing and using the Northstarz.Ai platform ("Platform") owned and
        operated by Novelio Technologies Private Limited ("Novelio," "we," "us,"
        or "our"), you agree to be bound by the terms and conditions of this
        Agreement ("Terms"). Your use of the Platform is subject to compliance
        with these Terms and any applicable policies, including but not limited
        to the Privacy Policy, Cancellation and Refund Policy, and any other
        relevant documents incorporated herein by reference.
      </p>
      <ul>
        <li>
          If you are accessing or using the Platform on behalf of a corporation,
          partnership, or any other entity, you represent and warrant that you
          have the authority to accept these Terms on behalf of such entity, and
          your use of the Platform constitutes acceptance by that entity.
        </li>
      </ul>
      <ol start="2">
        <li>Services and Subscriptions</li>
      </ol>
      <ul>
        <li>
          The Northstarz.Ai services ("Services") provided by Novelio are
          governed by these Terms, including the applicable policies available
          at https://www.interviewguru.co ("Website"). By contacting Novelio for
          services, availing the services, or registering on the Platform, you,
          as the Subscriber or Customer ("you" or "user"), acknowledge and agree
          to abide by these Terms and the Policies.
        </li>
      </ul>
      <ul>
        <li>
          This Agreement becomes effective upon your acceptance and governs the
          relationship between you and Novelio. Each party, Novelio and the
          Subscriber, is referred to as a "party," and collectively they are
          referred to as the "parties."
        </li>
      </ul>
      <ol start="3">
        <li>Definitions</li>
      </ol>
      <p>In this Agreement:</p>
      <ul>
        <li>
          "Affiliates" means any entity directly or indirectly controlled by,
          controlling, or under common control with Novelio, where "control"
          signifies ownership or control of over 50% of the voting interests.
        </li>
      </ul>
      <ul>
        <li>
          "Authorised User" refers to an individual user for whom a user licence
          has been purchased by the Subscriber, with unique user credentials to
          access the Northstarz.Ai platform. Authorised Users may include
          employees, contractors, or consultants of the Subscriber or its
          Affiliates.
        </li>
      </ul>
      <ul>
        <li>
          "Confidential Information" encompasses all information disclosed by
          one party ("Disclosing Party") to the other party ("Receiving Party"),
          whether oral or written, designated as confidential or reasonably
          understood to be confidential. Novelio&rsquo;s Confidential
          Information includes the terms of this Agreement and all Invoices.
        </li>
      </ul>
      <ul>
        <li>
          "Subscriber Data" denotes electronic data submitted to the
          Northstarz.Ai platform by the Subscriber.
        </li>
      </ul>
      <ul>
        <li>
          "Documentation" refers to user manuals and documentation provided by
          Novelio detailing the features, functionalities, and operation of the
          Northstarz.Ai platform.
        </li>
      </ul>
      <ul>
        <li>
          "Employee" or "Worker" includes employees, consultants, contingent
          workers, independent contractors, and retirees of the Subscriber and
          its Affiliates.
        </li>
      </ul>
      <ul>
        <li>
          "Improvements" encompass all updates, enhancements, error corrections,
          bug fixes, release notes, upgrades, and changes to the Service and
          Documentation, developed by Novelio and made available without an
          additional charge.
        </li>
      </ul>
      <ul>
        <li>
          "Intellectual Property" or "IP" includes all intellectual property,
          registered or not, such as patents, designs, literary works, artistic
          works, audio, video, computer programs, copyrights, trademarks, trade
          secrets, and any materials protected under intellectual property
          rights.
        </li>
      </ul>
      <ul>
        <li>
          "Law" refers to any local, state, national, and/or foreign law,
          treaties, and/or regulations applicable to the respective party.
        </li>
      </ul>
      <ul>
        <li>
          "Malicious Code" refers to viruses, worms, time bombs, Trojan horses,
          and other malicious code, files, scripts, agents, bots, or programs.
        </li>
      </ul>
      <ul>
        <li>
          "Order Form" denotes the ordering documents fully executed pursuant to
          this Agreement, under which the Subscriber subscribes to the Service.
        </li>
      </ul>
      <ul>
        <li>"Personal Data" has the definition set forth in Exhibit 3.</li>
      </ul>
      <ul>
        <li>
          "Production" signifies the Subscriber's use of or Novelio's written
          verification of the Service's availability for specific purposes.
        </li>
      </ul>
      <ul>
        <li>
          "Security Breach" includes any unauthorised use, loss, access to, or
          disclosure of Subscriber Data, as defined in applicable Law.
        </li>
      </ul>
      <ul>
        <li>
          "Northstarz.Ai Platform" refers to Novelio's software-as-a-service
          applications as described in the Documentation and subscribed to under
          an Order Form.
        </li>
      </ul>
      <ul>
        <li>
          "Non-Northstarz.Ai Services" denote third-party applications,
          services, software, networks, systems, websites, or databases
          integrated with the <strong>Northstarz.Ai </strong>
        </li>
      </ul>
      <ul>
        <li>
          "Invoice" is the document evidencing a subscription to Northstarz.Ai
          Services.
        </li>
      </ul>
      <ul>
        <li>
          "Subscriber Data" is electronic data and information submitted to and
          stored within the Northstarz.Ai platform by the Subscriber or an
          Authorised User.
        </li>
      </ul>
      <ul>
        <li>
          "Subscription Period(s)" refers to the duration of validity of each
          fee-based subscription plan purchased by the Subscriber.
        </li>
      </ul>
      <ul>
        <li>
          "Usage Limits" denote the limits on the use of the Northstarz.Ai
          Platform corresponding to the fee-based subscription plan purchased by
          the Subscriber.
        </li>
      </ul>
      <ul>
        <li>
          "Taxes" include all taxes, duties, levies, imposts, fines, or similar
          governmental assessments.
        </li>
      </ul>
      <ul>
        <li>
          "Terms of Service" refer to the terms and conditions for accessing and
          using the Northstarz.Ai platform, as modified from time to time.
        </li>
      </ul>
      <ol start="4">
        <li>Confidentiality</li>
      </ol>
      <ul>
        <li>
          The parties acknowledge and agree that all information exchanged
          between them, including but not limited to Confidential Information,
          shall be kept confidential and used solely for the purpose of this
          Agreement.
        </li>
      </ul>
      <ul>
        <li>
          Confidential Information does not include information that is or
          becomes public knowledge without a breach of obligation, was known to
          the receiving party prior to disclosure, is received from a third
          party without breach of any obligation, or is independently developed
          by the receiving party without the use of the disclosing party's
          Confidential Information.
        </li>
      </ul>
      <ol start="5">
        <li>Intellectual Property</li>
      </ol>
      <ul>
        <li>
          All Intellectual Property rights in the Northstarz.Ai platform,
          including but not limited to patents, copyrights, trademarks, and
          trade secrets, remain the exclusive property of Novelio Technologies
          Private Limited.
        </li>
      </ul>
      <ul>
        <li>
          The Subscriber acknowledges and agrees that it does not acquire any
          ownership rights in the Intellectual Property of Novelio Technologies
          Private Limited by using the Northstarz.Ai platform.
        </li>
      </ul>
      <ol start="6">
        <li>Subscriber Data and Privacy</li>
      </ol>
      <ul>
        <li>
          Novelio shall take reasonable measures to safeguard Subscriber Data
          and comply with applicable data protection laws.
        </li>
      </ul>
      <ul>
        <li>
          The Subscriber grants Novelio the right to use Subscriber Data for the
          sole purpose of providing the Northstarz.Ai services.
        </li>
      </ul>
      <ol start="7">
        <li>
          Personal Data is processed in accordance with the terms set forth in
          Exhibit 3.
        </li>
      </ol>
      <ul>
        <li>Service Level Agreement (SLA) and Security</li>
      </ul>
      <ul>
        <li>
          The Service Level Agreement and Security Agreement are integral parts
          of this Agreement and are incorporated herein by reference.
        </li>
      </ul>
      <ul>
        <li>
          Novelio shall make reasonable efforts to ensure the security and
          availability of the Northstarz.Ai platform.
        </li>
      </ul>
      <ol start="8">
        <li>Subscription and Fees</li>
      </ol>
      <ul>
        <li>
          The Subscriber agrees to pay the fees specified in the Invoice for the
          selected subscription plan.
        </li>
      </ul>
      <ul>
        <li>
          All fees are exclusive of Taxes, and the Subscriber is responsible for
          payment of any applicable Taxes.
        </li>
      </ul>
      <ol start="9">
        <li>Termination</li>
      </ol>
      <ul>
        <li>
          Either party may terminate this Agreement for cause upon written
          notice if the other party breaches any material term or condition.
        </li>
      </ul>
      <ul>
        <li>
          Upon termination, the Subscriber's access to the Northstarz.Ai
          platform is terminated, and Novelio may permanently delete Subscriber
          Data.
        </li>
      </ul>
      <ol start="10">
        <li>Governing Law and Dispute Resolution</li>
      </ol>
      <ul>
        <li>
          This Agreement shall be governed by and construed strictly in
          accordance with the laws of India (excluding the rules governing
          conflict of laws). Any dispute arising out of or resulting from this
          Agreement shall be subject to the exclusive jurisdiction of courts in
          Delhi-NCR to the exclusion of all other courts.
        </li>
      </ul>
      <ol start="11">
        <li>Rights Granted</li>
      </ol>
      <ul>
        <li>
          Subject to the terms and conditions of this Agreement, Novelio will
          make the Northstarz.Ai Platform available to Subscribers for the
          Subscription Period as outlined in the Invoice. Novelio grants the
          Subscriber a revocable, non-exclusive, non-transferable right, and
          limited licence to access, use, and, where applicable, download the
          Northstarz.Ai Platform during the Subscription Period for internal
          business purposes. In the event of exceeding the Usage Limits or
          functionalities within the Northstarz.Ai Platform, the Subscriber may
          purchase additional quantities by making payment(s) for such excess
          usage.
        </li>
      </ul>
      <ol start="12">
        <li>Usage Restrictions</li>
      </ol>
      <p>The Subscriber and its Authorised Users shall not:</p>
      <ul>
        <li>
          Copy, modify, create derivative works, or attempt unauthorised access
          to the Northstarz.Ai Platform.
        </li>
        <li>
          Attempt to disassemble, reverse engineer, or decompile the
          Northstarz.Ai Platform, except as permitted under applicable law.
        </li>
        <li>
          Use the Northstarz.Ai Platform on behalf of a third party or as part
          of a service bureau or business process service.
        </li>
        <li>
          Interfere with the integrity, security, or performance of the
          Northstarz.Ai Platform.
        </li>
        <li>
          Sell, resell, licence, sublicense, rent, lease, transfer, assign, or
          make the Northstarz.Ai Platform available to any third party without
          an Authorised User subscription.
        </li>
        <li>
          Use the Northstarz.Ai Platform to store or transmit malicious code or
          material that violates any third-party rights.
        </li>
        <li>Permit direct or indirect access circumventing Usage Limits.</li>
        <li>
          Use the Northstarz.Ai Platform in a manner that could harm
          Northstarz.Ai's servers, networks, computer systems, or resources.
        </li>
        <li>
          Share or use Authorised User licences with more than one individual,
          except by reassigning the licence to a new user.
        </li>
        <li>
          Remove or obscure proprietary notices contained in the Northstarz.Ai
          Platform.
        </li>
        <li>
          Gain unauthorised access to the Northstarz.Ai Platform or use it for
          competitive or benchmarking purposes.
        </li>
      </ul>
      <ol start="13">
        <li>Subscriber Responsibilities</li>
      </ol>
      <p>The Subscriber shall:</p>
      <ul>
        <li>
          Provide accurate information for access and use of the Northstarz.Ai
          Platform.
        </li>
        <li>
          Ensure Authorised Users' compliance with the Agreement, Documentation,
          and Invoice.
        </li>
        <li>
          Maintain the accuracy, quality, and legality of Subscriber Data.
        </li>
        <li>
          Use commercially reasonable efforts to prevent unauthorised access.
        </li>
        <li>
          Utilise the Northstarz.Ai Platform in accordance with this Agreement
          and applicable laws.
        </li>
        <li>
          Take responsibility for all activities under the Subscriber's account.
        </li>
        <li>Comply with all applicable laws and regulations.</li>
      </ul>
      <ol start="14">
        <li>Fees and Payments</li>
      </ol>
      <ul>
        <li>
          The Subscriber will pay the fees specified in the applicable Invoice.
          All payment obligations are non-cancellable and non-refundable,
          irrespective of active usage.
        </li>
      </ul>
      <ul>
        <li>
          Payments for Subscription Periods shall be made through online banking
          facilities. The Subscription Period begins upon receipt of payment or
          an acceptable purchase order.
        </li>
      </ul>
      <ul>
        <li>
          Undisputed overdue payments bear interest. Non-payment constitutes a
          material breach, allowing Novelio to block or suspend access until
          payment or terminate the Agreement.
        </li>
      </ul>
      <ul>
        <li>
          Subscriber must dispute invoices within five (5) business days.
          Disputes do not constitute default if Subscriber cooperates diligently
          and remits payment for undisputed amounts.
        </li>
      </ul>
      <ul>
        <li>
          Subscriber is responsible for paying Taxes in addition to applicable
          fees. Withholding Taxes must be paid directly to the government, with
          a tax certificate provided to Novelio within 100 days.
        </li>
      </ul>
      <ul>
        <li>
          Novelio reserves the right to unilaterally determine and modify
          pricing, with agreed pricing remaining in effect during the term
          specified in the Invoice.
        </li>
      </ul>
      <ol start="15">
        <li>Availability and Technical Support</li>
      </ol>
      <ul>
        <li>
          Novelio will make the Northstarz.Ai Platform available 24/7, subject
          to Scheduled/Pa Downtime and Force Majeure Events.
        </li>
      </ul>
      <ul>
        <li>
          Northstarz.Ai Platform will have a Monthly Uptime Percentage of 99%.
        </li>
      </ul>
      <ul>
        <li>
          Periodically, Novelio introduces new features in the Northstarz.Ai
          Platform with enhanced functionality. Features and functionality will
          be made available as part of a major feature release (&ldquo;Feature
          Release&rdquo;) or as part of weekly service updates (&ldquo;Service
          Updates&rdquo;).
        </li>
      </ul>
      <ul>
        <li>Calculation of Northstarz.Ai SLA Service Credit:</li>
      </ul>
      <table width="538">
        <tbody>
          <tr>
            <td width="171">
              <p>Uptime</p>
            </td>
            <td width="367">
              <p>Compensation (% of Monthly Subscription Fees)</p>
            </td>
          </tr>
          <tr>
            <td width="171">
              <p>&nbsp;99%</p>
            </td>
            <td width="367">
              <p>5%</p>
            </td>
          </tr>
          <tr>
            <td width="171">
              <p>&lt;99%</p>
            </td>
            <td width="367">
              <p>15%</p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul>
        <li>
          In order to receive any of the Northstarz.Ai SLA Service Credits
          described above, Subscriber must notify Novelio within ten (10) days
          from the time Subscriber becomes eligible to receive a Northstarz.Ai
          SLA Service Credit. Failure to comply with this requirement will
          result in forfeiture of Subscriber&rsquo;s right to receive a Service
          Credit.
        </li>
        <li>
          Northstarz.Ai SLA Service Credits will not be exchanged for, or
          converted to, monetary compensation.
        </li>
        <li>
          Subscriber&rsquo;s sole and exclusive remedy for Novelio&rsquo;s
          failure to meet the uptime commitment is to receive Interview SLA
          Service Credit.
        </li>
        <li>
          Novelio will provide support for the functionality delivered by
          Northstarz.Ai Platform. However, concerning any other functionality,
          issues, errors in the Northstarz.Ai Platform arising from problems,
          errors, or modifications in Subscriber's information systems,
          customizations, and/or third-party products or services, Novelio may
          offer assistance to Subscriber and its third-party providers in
          identifying and resolving such issues or errors. Instances where
          obligations or commitments under this SLA are not fulfilled due to (i)
          acts or omissions by the Subscriber, and (ii) events of force majeure,
          will be excused.
        </li>
      </ul>
      <ol start="16">
        <li>Privacy and Security</li>
      </ol>
      <ul>
        <li>
          Novelio processes Personal Information in compliance with applicable
          legal requirements, as outlined in Exhibit 3.
        </li>
      </ul>
      <ul>
        <li>
          Novelio maintains industry-standard safeguards for security,
          confidentiality, and integrity of Subscriber Data, detailed in Exhibit
          1.
        </li>
      </ul>
      <ol start="17">
        <li>Proprietary Rights and Licences</li>
      </ol>
      <ul>
        <li>
          Novelio retains all rights, title, and interest in the Northstarz.Ai
          Platform and Documentation. Subscriber agrees any other use
          constitutes a material breach and infringement.
        </li>
      </ul>
      <ul>
        <li>
          Subscriber grants Novelio a licence to use and incorporate any
          feedback provided into the Northstarz.Ai Platform.
        </li>
      </ul>
      <ul>
        <li>
          Novelio has a licence to use Subscriber Input without obligation to
          make it an Improvement.
        </li>
      </ul>
      <ul>
        <li>
          Novelio has exclusive rights to use Aggregated Data for business
          purposes, ensuring individual or specific data identity remains
          confidential.
        </li>
      </ul>
      <ul>
        <li>
          Northstarz.Ai's name usage requires prior written permission.
          Northstarz.Ai may use Subscriber involvement in credentials,
          proposals, and publicity material.
        </li>
      </ul>
      <ol start="18">
        <li>Confidentiality</li>
      </ol>
      <ul>
        <li>
          The Receiving Party must use reasonable care to protect Confidential
          Information, limiting access to authorised personnel. Copies shall be
          returned or destroyed upon request or termination.
        </li>
      </ul>
      <ul>
        <li>
          The Receiving Party may disclose Confidential Information as required
          by law, providing notice to the Disclosing Party.
        </li>
      </ul>
      <ol start="19">
        <li>Representations, Warranties, and Disclaimers</li>
      </ol>
      <ul>
        <li>
          Each party represents its validity and authority to enter into the
          Agreement.
        </li>
      </ul>
      <ul>
        <li>
          Novelio warrants the Northstarz.Ai Platform's performance and security
          safeguards. In case of breach, Subscriber has remedies as outlined in
          the Agreement.
        </li>
      </ul>
      <ul>
        <li>
          Northstarz.Ai Platform is provided "as is," and Novelio disclaims all
          warranties, except those explicitly
        </li>
      </ul>
      <ol start="20">
        <li>Indemnification</li>
      </ol>
      <ul>
        <li>Indemnification by Novelio</li>
      </ul>
      <ul>
        <li>
          Northstarz.Ai, a platform provided by Novelio Technologies Private
          Limited, shall defend the Subscriber, at Northstarz.Ai&rsquo;s
          expense, from claims, demands, suits, or proceedings made or brought
          against the Subscriber by a third party ("Claims") alleging that the
          use of the Northstarz.Ai Platform as contemplated hereunder infringes
          such third party&rsquo;s Intellectual Property Rights. Northstarz.Ai
          shall indemnify and hold the Subscriber harmless against any loss,
          damage, or costs finally awarded or entered into in settlement
          (including, without limitation, reasonable attorneys' fees)
          ("Losses"). This indemnification is subject to the following
          conditions:
        </li>
      </ul>
      <ul>
        <li>
          The Subscriber must promptly give written notice of the Claim to
          Northstarz.Ai, with any delay not relieving Northstarz.Ai of its
          obligations under this section except to the extent that Northstarz.Ai
          is prejudiced by such delay.
        </li>
      </ul>
      <ul>
        <li>
          The Subscriber must give Northstarz.Ai sole control of the defence and
          settlement of the Claim (although Northstarz.Ai may not settle any
          Claim unless it unconditionally releases the Subscriber of all
          liability).
        </li>
      </ul>
      <ul>
        <li>
          The Subscriber must provide to Northstarz.Ai, at Northstarz.Ai's cost,
          all reasonable assistance.
        </li>
      </ul>
      <ul>
        <li>
          Northstarz.Ai shall have no liability for Claims or Losses to the
          extent arising from:
        </li>
      </ul>
      <ul>
        <li>
          Modification of the Northstarz.Ai Platform by anyone other than
          Northstarz.Ai.
        </li>
      </ul>
      <ul>
        <li>
          Use of the Northstarz.Ai Platform in a manner inconsistent with the
          Agreement or Documentation.
        </li>
      </ul>
      <ul>
        <li>
          Use of the Northstarz.Ai Platform in combination with any other
          product or service not provided by Northstarz.Ai.
        </li>
      </ul>
      <ul>
        <li>
          If the Subscriber is enjoined from using the Northstarz.Ai Platform or
          Northstarz.Ai reasonably believes it will be enjoined, Northstarz.Ai
          shall have the right, at its sole option, to obtain for the Subscriber
          the right to continue using the Northstarz.Ai Platform or to replace
          or modify the Northstarz.Ai Platform so that it is no longer
          infringing. If neither of the foregoing options is reasonably
          available to Northstarz.Ai, then the Agreement may be terminated at
          either party&rsquo;s option, and Northstarz.Ai&rsquo;s sole liability,
          in addition to the indemnification obligations herein, shall be to
          refund any prepaid fees for the Northstarz.Ai Platform that was to be
          provided after the effective date of termination.
        </li>
      </ul>
      <ul>
        <li>Indemnification by the Subscriber</li>
      </ul>
      <ul>
        <li>
          The Subscriber agrees to indemnify and hold harmless Northstarz.Ai,
          its directors, officers, employees, affiliates, agents, and
          representatives from and against any and all claims, damages,
          liabilities, fines, penalties, costs, and expenses (including
          reasonable attorneys' fees) to which Northstarz.Ai may be subjected as
          a result of the Subscriber's, its employees', or agents' business
          operations, including, without limitation, Subscriber employee claims,
          any act or omission constituting a breach of this Agreement, or
          performance hereunder in a manner that is negligent, grossly
          negligent, reckless, or improper.
        </li>
      </ul>
      <ul>
        <li>
          The Subscriber recognizes that Northstarz.Ai will be irreparably
          harmed by a violation of the Subscriber&rsquo;s confidentiality,
          non-use, or other obligations hereunder. Therefore, in addition to any
          other available remedies, Northstarz.Ai is entitled to an injunction
          or other decree of specific performance with respect to any violation
          thereof by the Subscriber.
        </li>
      </ul>
      <ol start="21">
        <li>Limitation of Liability</li>
      </ol>
      <ul>
        <li>
          Under no circumstances and under no legal theory, whether tort,
          contract, product liability, negligence, or otherwise, shall
          Northstarz.Ai or its affiliates be liable to the Subscriber or any
          other affiliate or third party for any lost profits, lost sales or
          lost revenue, loss of data, business interruption, loss of goodwill,
          or for any indirect, special, incidental, exemplary, consequential, or
          punitive damages, even if a party or its affiliates have been advised
          of the possibility of such damages. In no event shall the liability of
          either party to the other party or its affiliates for any claim or
          action arising out of this Agreement exceed the value of 10% of the
          aggregate of all amounts paid by the Subscriber to Northstarz.Ai in
          the twelve (12) months preceding the first event giving rise to such
          claim or action. The limitations specified herein will not limit the
          Subscriber&rsquo;s obligation to pay fees in accordance with this
          Agreement.
        </li>
      </ul>
      <ol start="22">
        <li>Term of Termination</li>
      </ol>
      <ul>
        <li>Term</li>
      </ul>
      <ul>
        <li>
          The term of this Agreement shall commence on the Effective Date and
          shall thereafter continue for the duration of the Subscription Period
          of the relevant Invoice, unless terminated in accordance with the
          provisions of this Section. Except as otherwise specified in the
          Agreement or Invoice, subscriptions will automatically renew for
          additional terms equivalent to the expiring Subscription Period.
        </li>
      </ul>
      <ul>
        <li>Termination for Cause</li>
      </ul>
      <ul>
        <li>
          A party may terminate this Agreement for cause: (i) upon 30 days'
          written notice to the other party of a material breach if such breach
          remains uncured at the expiration of such period, or (ii) if the other
          party becomes the subject of a petition in bankruptcy or any other
          proceeding relating to insolvency, receivership, liquidation, or
          assignment for the benefit of the creditors.
        </li>
      </ul>
      <ul>
        <li>Termination by Northstarz.Ai</li>
      </ul>
      <ul>
        <li>
          Northstarz.Ai shall be entitled to terminate this Agreement forthwith
          upon giving written notice of thirty (30) days to the Subscriber if
          it:
        </li>
      </ul>
      <ul>
        <li>
          enters an agreement with creditors without authorization from
          Northstarz.Ai and/or steps have been taken for its winding up (other
          than for the purposes of bona fide reconstruction);
        </li>
        <li>
          has reasonable grounds to suspect that it has participated in illegal
          practices and/or acts or has been charged in a court of law for acts
          prejudicial to the interests of Northstarz.Ai;
        </li>
        <li>
          commits misconduct, fraudulent, dishonest, undisciplined conduct, or
          breach of integrity or embezzlement or misappropriation or misuse or
          causing damage to the Software and other property of Northstarz.Ai;
          (iv) misrepresents, makes false statements, and breaches the
          representations and warranties under the Agreement; and (v) ceases or
          threatens to cease to carry on business.
        </li>
      </ul>
      <ul>
        <li>Termination for Convenience</li>
      </ul>
      <ul>
        <li>
          Notwithstanding any other provision in this Agreement, Northstarz.Ai
          shall, at its absolute discretion, be entitled to terminate this
          Agreement without providing reasons by giving at least 30 (thirty)
          days prior written notice to the other Party.
        </li>
      </ul>
      <ul>
        <li>Refund</li>
      </ul>
      <ul>
        <li>
          Upon termination for cause by the Subscriber, Northstarz.Ai shall
          refund the Subscriber any prepaid fees covering the unused portion of
          the Subscription Period. Upon any termination for cause by
          Northstarz.Ai, the Subscriber shall expedite all payments due to
          Northstarz.Ai, and in no event will the termination of this Agreement
          relieve the Subscriber of its obligation to pay any fees due to
          Northstarz.Ai. In the event the Subscriber terminates the Agreement
          except as mentioned in Section 11.2 of the Agreement, Northstarz.Ai is
          under no obligation to refund the fees paid by the Subscriber.
        </li>
      </ul>
      <ul>
        <li>Retrieval of Subscriber Data</li>
      </ul>
      <ul>
        <li>
          Upon the Subscriber&rsquo;s written request made on or before the
          expiration or termination of the Agreement, Northstarz.Ai will provide
          the Subscriber limited access to the Northstarz.Ai Platform for up to
          thirty (30) days, at no additional cost, solely for the purpose of
          retrieving Subscriber Data. Subject to such a thirty-day period and
          Northstarz.Ai&rsquo;s legal obligations, Northstarz.Ai has no
          obligation to maintain or provide any Subscriber Data and may, unless
          legally prohibited, delete Subscriber Data. However, Northstarz.Ai
          will not be required to remove copies of the Subscriber Data from its
          backup media and servers until such time as the backup copies are
          scheduled to be deleted.
        </li>
      </ul>
      <ul>
        <li>Surviving Provisions</li>
      </ul>
      <ul>
        <li>
          Sections "Confidentiality," "Fees and Payments," "Warranty
          Disclaimers," "Limitation of Liability," "Indemnification,"
          "Termination," "Surviving Provisions," and "General" shall survive
          termination of this Agreement.
        </li>
      </ul>
      <ol start="23">
        <li>General</li>
      </ol>
      <ul>
        <li>Applicability of Terms of Service</li>
      </ul>
      <ul>
        <li>
          The Subscriber understands that, in addition to the terms of this
          Agreement, Northstarz.Ai's Terms of Service will apply to the
          Subscriber's access and use of the Northstarz.Ai Platform. In the
          event of any conflict between this Agreement and the Terms of Service,
          the terms of this Agreement shall prevail.
        </li>
      </ul>
      <ol start="24">
        <li>Entire Agreement</li>
      </ol>
      <ul>
        <li>
          This Agreement, including the Exhibits attached hereto and the Terms
          of Service, constitutes the entire agreement between the parties with
          respect to the subject matter of this Agreement and supersedes any and
          all prior and contemporaneous agreements, negotiations,
          correspondence, understandings, and communications between the
          parties, whether written or oral, concerning the subject matter
          hereof.
        </li>
      </ul>
      <ol start="25">
        <li>Amendment</li>
      </ol>
      <ul>
        <li>
          No changes, modifications, or amendments of any nature made to this
          Agreement shall be valid unless evidenced in writing and signed for
          and on behalf of both parties by their respective authorised
          representatives.
        </li>
      </ul>
      <ol start="26">
        <li>Notices</li>
      </ol>
      <ul>
        <li>
          All notices required under this Agreement shall be in writing and
          shall be sent to the respective address set forth below. Any such
          notice may be delivered by hand, by overnight courier, by registered
          post or certified mail with return receipt requested, or by electronic
          mail to the person to whom such notice is to be sent as per the terms
          of this Agreement. Such notice shall be deemed to have been received:
          (i) by hand delivery, at the time of delivery; (ii) by overnight
          courier, on the succeeding business day; (iii) by registered post or
          certified mail, on the date marked in proof of receipt; and (iv) by
          electronic mail, when sent. All notices shall be sent to: Legal Team
          on support@northstarz.ai
        </li>
      </ul>
      <ol start="27">
        <li>Relationship of the Parties</li>
      </ol>
      <ul>
        <li>
          The parties are independent contractors. This Agreement does not
          create a partnership, franchise, joint venture, agency, fiduciary, or
          employment relationship between the parties. Neither party shall have
          the power to bind the other or incur obligations on the other party's
          behalf without the other party's written consent.
        </li>
      </ul>
      <ol start="28">
        <li>Assignment</li>
      </ol>
      <ul>
        <li>
          Neither party shall assign any of its rights or obligations hereunder,
          whether by operation of law or otherwise, without the prior written
          consent of the other party (which consent shall not be unreasonably
          withheld). Any attempt by a party to assign its rights or obligations
          under this Agreement other than as permitted by this section shall be
          void and of no effect. Subject to the foregoing, this Agreement shall
          bind and inure to the benefit of the parties, their respective
          successors, and permitted assigns.
        </li>
      </ul>
      <ol start="29">
        <li>Affairs of the Parties</li>
      </ol>
      <ul>
        <li>
          It has been explicitly agreed between the Parties that at any time
          within the term of this Agreement, if the Subscriber undergoes one of
          the following, including the sale of the company/entity, then the
          Subscriber shall have the sole unconditional rights, among others, to:
        </li>
      </ul>
      <ul>
        <li>Change in the management;</li>
        <li>Change in the corporate name or brand name or trademark;</li>
        <li>Restructuring;</li>
        <li>Acquisition and merger;</li>
        <li>Any Private Equity or Loan infusion into the Party.</li>
      </ul>
      <p>
        Northstarz.Ai will not interfere or raise any objections under the above
        circumstances, provided that the Subscriber shall ensure that the rights
        of Northstarz.Ai under this Agreement is not adversely affected or
        curtailed by such an event. The existence of the Agreement and the
        rights of Northstarz.Ai under this Agreement shall not be affected in
        any manner, and the Subscriber shall ensure the same terms and
        conditions are carried through the Term of the Agreement. If the
        Agreement terminates or any rights of Northstarz.Ai are adversely
        affected due to any of the above circumstances as laid down under this
        clause above, then the defaulting party, i.e., the Subscriber shall
        indemnify Northstarz.Ai and compensate it from any loss or expenditure
        that Northstarz.Ai incurs.
      </p>
      <ol start="30">
        <li>No Third-Party Beneficiaries</li>
      </ol>
      <ul>
        <li>
          The provisions of this Agreement shall be binding and inure solely to
          the benefit of the parties, their successors, and permitted assigns.
          Nothing herein, whether express or implied, will confer any right,
          benefit, or remedy upon any person or entity other than the parties,
          their successors, and permitted assigns.
        </li>
      </ul>
      <ol start="31">
        <li>Force Majeure</li>
      </ol>
      <ul>
        <li>
          No Party shall be liable to the other if, and to the extent, that the
          performance or delay in performance of any of its obligations under
          this Agreement is prevented, restricted, delayed, or interfered with
          due to circumstances beyond the reasonable control of such Party,
          including but not limited to Government legislations, fires, floods,
          explosions, epidemics, accidents, acts of God, wars, riots, strikes,
          lockouts, or other concerted acts of workmen, acts of Government. The
          Party claiming an event of force majeure shall promptly notify the
          other Party in writing and provide full particulars of the cause or
          event and the date of the first occurrence thereof, as soon as
          possible after the event and also keep the other Party informed of any
          further developments. The Party so affected shall use its best efforts
          to remove the cause of non-performance, and the Parties shall resume
          performance as soon as such cause is removed.
        </li>
      </ul>
      <ol start="32">
        <li>Severability</li>
      </ol>
      <ul>
        <li>
          Any provision of this Agreement, which is prohibited or unenforceable
          in any jurisdiction, shall, as to such jurisdiction, be ineffective to
          the extent of such prohibition or unenforceability without
          invalidating the remaining provisions hereof or affecting the validity
          or enforceability of such provision in any other jurisdiction.
          Accordingly, this Agreement shall be construed as if such a portion
          had not been inserted, and the remaining provisions of this Agreement
          shall remain in full force and effect.
        </li>
      </ul>
      <ol start="33">
        <li>Waiver</li>
      </ol>
      <ul>
        <li>
          Except as otherwise provided in this Agreement, failure on the part of
          either Party to exercise any right hereunder or to insist upon strict
          compliance by the other Party with any of the terms, covenants, or
          conditions hereof shall not be deemed a waiver of such right, term,
          covenant, or condition.
        </li>
      </ul>
      <ol start="34">
        <li>Interpretation</li>
      </ol>
      <ul>
        <li>
          No provision of this Agreement shall be construed against one party by
          reason of being deemed the "author" of the Agreement. The headings
          used in this Agreement are for convenience only and shall not affect
          the interpretation of the terms of this Agreement.
        </li>
      </ul>
      <p>
        <strong>This space left blank intentionally</strong>
      </p>
      <p>
        <strong>Appendix</strong>
      </p>
      <p>
        <strong>Exhibit 1</strong>
      </p>
      <p>
        <strong>SECURITY INFORMATION</strong>
      </p>
      <p>
        Your employee information is consistently safeguarded and readily
        accessible at all times. Every facet of our security procedures,
        including storing, transferring, accessing, backing up, monitoring,
        testing, and reviewing, is meticulously designed to adhere to industry
        best practices.
      </p>
      <ol>
        <li>Data Privacy and Data Access</li>
      </ol>
      <p>
        Our commitment to a secure and trustworthy environment for your
        subscription data is unwavering. To achieve this, we employ a
        cross-functional approach with initiatives both comprehensive and
        meticulous. The following outlines the key components of our privacy and
        security protocols.
      </p>
      <ol start="2">
        <li>Restricted access to Databases and data storages</li>
      </ol>
      <p>
        Access to databases and data storages is limited to three senior
        executives within the organization, ensuring that developers do not have
        direct access. Developers can only interact with the data through
        independently designed authentication gateways. These gateways
        incorporate a proprietary querying engine that masks private and
        personally identifiable information, while also implementing throttling
        and auditing for all data query operations.
      </p>
      <ol start="3">
        <li>Restricted support personnel access</li>
      </ol>
      <p>
        Customer support personnel require access to your portal for assistance,
        and Novelio has implemented stringent measures to protect privacy. To
        access any information, a Novelio support person must be explicitly
        granted access by you, and they are provided with a secure one-time
        random password generated for each support incident. These temporary
        credentials can be terminated by the customer within minutes or
        automatically expire within an hour if not terminated.
      </p>
      <ol start="4">
        <li>No local or on-premise storage of data</li>
      </ol>
      <p>
        Novelio exclusively leverages Google cloud infrastructure, each with its
        private network. We do not utilize any local or on-premise
        infrastructure for storing customer information in our development or
        test environments.
      </p>
      <ol start="5">
        <li>GDPR Compliance</li>
      </ol>
      <p>
        Novelio is committed to maintaining compliance with the EU's General
        Data Protection Regulation (GDPR), ensuring that our product features,
        corporate protocols, and legal documents facilitate compliance for our
        users and customers.
      </p>
      <ol start="6">
        <li>Application security</li>
      </ol>
      <p>In-transit Encryption</p>
      <p>
        Sessions between you and your portal are protected with in-transit
        encryption, utilising 2,048-bit or better keys and TLS 1.0 or above.
        Modern browsers will use TLS 1.2 or 1.3.
      </p>
      <p>Web Application and Network Firewalls</p>
      <p>
        Novelio diligently monitors potential attacks with tools including web
        application firewalls and network-level firewalls. Additionally, the
        Novelio platform incorporates Distributed Denial of Service (DDoS)
        prevention defences.
      </p>
      <p>Software Development Lifecycle (SDLC) Security</p>
      <p>
        Novelio employs static code analysis tools and human review processes to
        ensure consistent quality in our software development practices. Our
        secure coding practices align with OWASP guidance.
      </p>
      <ol start="7">
        <li>Datacenter Protections</li>
      </ol>
      <p>Physical Security</p>
      <p>
        Novelio products are hosted with cloud infrastructure providers
        possessing SOC 2 Type II and ISO 27001 certifications, among others.
        Certified protections include dedicated security staff, strictly managed
        physical access control, and video surveillance.
      </p>
      <p>Patch Management</p>
      <p>
        Our patch management process identifies and addresses missing patches
        within the product infrastructure. Server-level instrumentation ensures
        that tracked software packages use the appropriate versions.
      </p>
      <p>Security Incident Response</p>
      <p>
        Novelio's security incident process flows and investigation data sources
        are pre-defined during recurring preparation activities and exercises.
        We adhere to standard incident response process structures to ensure the
        right steps are taken at the right time.
      </p>
      <ol start="8">
        <li>Audits, Vulnerability Assessment &amp; Penetration Testing</li>
      </ol>
      <p>Vulnerability Assessment</p>
      <p>
        Novelio conducts recurring vulnerability assessments, including static
        code analysis and infrastructure vulnerability scans.
      </p>
      <p>Penetration Testing</p>
      <p>
        We leverage third-party penetration testing firms multiple times a year
        to assess Novelio products and product infrastructure.
      </p>
      <p>External Audit &amp; Certification</p>
      <p>
        Regular external audits and certifications are conducted by Novelio to
        ensure continued adherence to security standards.
      </p>
      <ol start="9">
        <li>Resiliency and Availability</li>
      </ol>
      <p>
        99% Uptime - Novelio consistently maintains an availability rate above
        99%. Customer data is 100% backed up to multiple online replicas with
        additional snapshots.
      </p>
      <ol start="10">
        <li>24x7x365 Monitoring</li>
      </ol>
      <p>
        Our product and operations team continually monitor application,
        software, and infrastructure behavior using proprietary and
        industry-recognized solutions.
      </p>
      <ol start="11">
        <li>Data Center Redundancy</li>
      </ol>
      <p>
        Novelio ensures multiple failover instances are in place to prevent
        outages from single points of failure.
      </p>
      <ol start="12">
        <li>Disaster Recovery</li>
      </ol>
      <p>
        Robust controls are implemented for data and application code recovery,
        with a Recovery Point Objective (RPO) and Recovery Time Objective (RTO)
        of 5 seconds and 1 hour, respectively, for data within the same
        geography. In the event of a natural disaster affecting different
        geographies, RPO and RTO are 12 hours and 1 hour, respectively. A 45-day
        point in time restoration feature allows restoration to any desired date
        and time within the last 45 days.
      </p>
      <p>
        <strong>Exhibit 2</strong>
      </p>
      <p>
        <strong>SERVICE LEVEL AVAILABILITY</strong>
      </p>
      <p>
        This Exhibit constitutes the Service Level Availability Policy ("SLA")
        of Novelio&rsquo;s for its Subscribers, and the terms herein shall have
        the same meaning as defined in the Master Subscription Agreement.
      </p>
      <ol>
        <li>Definitions</li>
      </ol>
      <ul>
        <li>
          1. Downtime: Refers to the incapacity to access the Northstarz.Ai
          Platform due to a Qualifying Fault. Measurement relies on
          Novelios&rsquo;s monitoring tools assessing the availability of the
          Northstarz.Ai Platform.
        </li>
        <li>
          2. Qualifying Fault: Includes server-side errors and reachability
          errors attributable to the Northstarz.Ai Platform.
        </li>
        <li>
          3. Downtime Period: Denotes ten (10) or more consecutive minutes of
          Downtime. Intermittent Downtime for less than ten minutes will not be
          considered within any Downtime Periods.
        </li>
        <li>
          4. Monthly Uptime: Represents the total number of minutes in a
          calendar month minus the number of minutes of Downtime suffered from
          all Downtime Periods in that month.
        </li>
        <li>
          5. Monthly Uptime Percentage: Calculated by dividing Monthly Uptime by
          the total number of minutes in a calendar month.
        </li>
        <li>
          6. Scheduled Downtime: Denotes the informed unavailability of the
          Northstarz.Ai Platform, communicated to Subscriber at least
          forty-eight (48) hours in advance. Scheduled Downtime does not
          constitute a Qualifying Fault.
        </li>
        <li>
          7. Novelio SLA Service Credit note: Denotes Novelio Service Credit
          note raised for Novelio&rsquo;s failure to meet the monthly uptime
          commitment at no additional cost.
        </li>
      </ul>
      <ol>
        <li>Novelio Support Scope</li>
      </ol>
      <ul>
        <li>
          1. Novelio will provide support for functionality delivered by Novelio
          as part of the Northstarz.Ai Platform. However, for all other
          functionality and/or issues or errors in the Northstarz.Ai Platform
          resulting from Subscriber's information systems, customizations,
          and/or third-party products or services, Novelio may assist Subscriber
          and its third-party providers in diagnosing and resolving issues or
          errors. Subscriber acknowledges that these matters fall outside
          Novelio's support obligations. Failure to meet obligations or
          commitments under this SLA attributable to:
        </li>
      </ul>
      <ol>
        <li>Subscriber's acts or omissions, and</li>
        <li>force majeure events shall be excused.</li>
      </ol>
      <ol>
        <li>Issue Submission and Reporting</li>
      </ol>
      <p>
        The registered contacts may submit cases to Novelio Support through the
        Support Portal or Support phone number. Each case will be assigned a
        unique case number, and Novelio will respond and work towards resolution
        according to this SLA.
      </p>
      <ol>
        <li>Severity Level Determination</li>
      </ol>
      <p>
        Subscriber shall reasonably self-diagnose each support issue and
        recommend to Novelio an appropriate Severity Level designation. Novelio
        shall validate Subscriber's Severity Level designation or notify
        Subscriber of any change, with justification. Severity Levels are
        defined as follows:
      </p>
      <ul>
        <li>
          Severity Level 1: The software, as a whole, is non-functional or not
          accessible; unauthorised exposure of all or part of the client's data;
          or loss or corruption of all or part of the client's data.
        </li>
        <li>
          Severity Level 2: Significant and/or ongoing interruption of an
          authorised user&rsquo;s use of a critical function of the software,
          with no acceptable work-around available.
        </li>
        <li>
          Severity Level 3: Minor and/or limited interruption of an authorised
          user&rsquo;s use of a non-critical function of the software; or
          problems not included in Severity Levels 1 or 2.
        </li>
        <li>
          Severity Level 4: General questions about the software; or
          configuration changes previously agreed to be in scope by the client.
        </li>
      </ul>
      <ol>
        <li>&nbsp;Response and Resolution</li>
      </ol>
      <table width="556">
        <tbody>
          <tr>
            <td width="73">
              <p>
                <strong>Severity Level</strong>
              </p>
            </td>
            <td width="132">
              <p>
                <strong>Response (business hours)</strong>
              </p>
            </td>
            <td width="191">
              <p>
                <strong>
                  Problem Determination (business hours/business days)
                </strong>
              </p>
            </td>
            <td width="160">
              <p>
                <strong>Restoration/Work-around (business days)</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td width="73">
              <p>1</p>
            </td>
            <td width="132">
              <p>2 Hour</p>
            </td>
            <td width="191">
              <p>4 Hours</p>
            </td>
            <td width="160">
              <p>8 Hours</p>
            </td>
          </tr>
          <tr>
            <td width="73">
              <p>2</p>
            </td>
            <td width="132">
              <p>2 Hours</p>
            </td>
            <td width="191">
              <p>4 Hours</p>
            </td>
            <td width="160">
              <p>3 Days</p>
            </td>
          </tr>
          <tr>
            <td width="73">
              <p>3</p>
            </td>
            <td width="132">
              <p>2 Hours</p>
            </td>
            <td width="191">
              <p>3 Days</p>
            </td>
            <td width="160">
              <p>10 Days</p>
            </td>
          </tr>
          <tr>
            <td width="73">
              <p>4</p>
            </td>
            <td width="132">
              <p>3 Days</p>
            </td>
            <td width="191">
              <p>10 Days</p>
            </td>
            <td width="160">
              <p>14 Days</p>
            </td>
          </tr>
        </tbody>
      </table>
      <ol>
        <li>Exclusions</li>
      </ol>
      <ul>
        <li>
          1. The SLA does not apply to performance and availability issues
          caused by factors outside Novelio&rsquo;s reasonable control; issues
          resulting from any actions or inactions of Subscriber; or issues
          resulting from Subscriber&rsquo;s equipment and/or third-party
          equipment not within Novelio&rsquo;s reasonable control.
        </li>
      </ul>
      <p>
        <strong>Exhibit 3</strong>
      </p>
      <p>
        <strong>Data Protection Policy</strong>
      </p>
      <p>
        Northstarz.Ai (A product of Novelio Technologies Private Limited) is
        committed to adhering to the General Data Protection Regulation (GDPR).
        We maintain product features, corporate protocols, and legal documents
        to help our users and customers comply. The following are some of the
        frequently asked questions to help our customers, employees and
        candidates. The detailed policy can be accessed here.
      </p>
      <p>
        <strong>What data do we collect?</strong>
      </p>
      <p>
        We collect what is being gathered through the Service consists of any
        personal, employment, payroll, and location information provided
        consciously and voluntarily by a Customer (Employer or its authorised
        partners/employee), End User or the Customer&rsquo;s administrator or
        through use of our platform. The employers, through our hiring platform,
        may also collect information from a job-seeking candidate. In addition,
        the employer might seek location information for time-keeping purposes.
      </p>
      <p>
        <strong>What is our privacy policy?</strong>
      </p>
      <p>
        Our privacy policy can be accessed <strong>here </strong>and covers all
        aspects of GDPR adherence in much detail.
      </p>
      <p>
        <strong>Who is responsible for employee data?</strong>
      </p>
      <p>
        Any Northstarz.Ai (A product of Novelio technologies Private Limited)
        customer that uses our services to store their employee or candidate
        information, owns the data of all employees. The responsibility of
        updating and deleting all employee data therefore lies with the
        customer. We provide our customers with necessary support (customer
        support/ product features) to carry out any such requests however and
        whenever the customer wants to.
      </p>
      <p>
        <strong>For how long is the data stored?</strong>
      </p>
      <p>
        It depends on the contract with our customer. By default, we store data
        until it's explicitly removed. But we provide provisions to set up a
        periodic data removal process for our clients on a contract-to-contract
        basis. However, we always support data deletion through requests sent to{" "}
        <u>support@northstarz.ai</u> for all of our customers. We delete data at
        the specified/ requested time by our customers with an additional grace
        period.
      </p>
      <p>
        <strong>Who has access to the data</strong>
      </p>
      <p>
        - Customer representatives who have access to our platform services to
        maintain employee data.
      </p>
      <p>
        - Northstarz.Ai internal team only when a support request is raised by
        the Customer and data access is necessary to support such request.
      </p>
      <p>
        <strong>Who can delete the employee information</strong>
      </p>
      <p>
        The data retention is governed by the agreement between a customer
        (employer or authorised partners) and the candidates. The customer is
        thus responsible for any deletion of any candidate's information.
      </p>
      <p>
        <strong>Can the deleted data be reinstated?</strong>
      </p>
      <p>
        An exit action on an employee continues to retain all the information of
        the employee in the system. The actual deletion action is permanent and
        cannot be reinstated.
      </p>
      <p>
        <strong>
          Can I delete/ edit/ view/ access my personal information?
        </strong>
      </p>
      <p>
        Northstarz.Ai is a Service provider and your data provided by the
        candidates, is owned by the customer who manages your access. Please
        contact your employer (customer) directly to request the deletion or
        updation of your data collected during the interview process..
      </p>
    </div>
  );
};

export default Terms;
